import {getRenderComponentById, getRenderComponentsById, updateRenderComponentAttr} from '../../../store/common/action';
import {parseParam} from '../index';
import {PARAMETER_TYPE} from "../constant";

/**
 * 获取表单所有字段的值
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const getFormAllValue = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) > 0) {
    // 当前表单prop
    const prop = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId)
    // 获取到单前需要的表单
    const comp = getRenderComponentById(instanceId, prop);
    // 获取到表单所有子节点数组
    const childList = _get(comp, ['children']);
    const mapping = _get(comp, ['attrs', 'fieldMapping', 'value'])
    let slotList = []
    if (_size(childList) > 0) {
      // 获取到表单下所有的插槽
      for (const child of childList) {
        const board = getRenderComponentById(instanceId, child.prop).children
        slotList = [...slotList, ...board];
      }
    }
    const formData = {}
    if (_size(childList) > 0) {
      for (const child of slotList) {
        const slot = getRenderComponentById(instanceId, child.prop);
        // 模板id
        const templateId = _get(slot, ['attrs', 'templateId', 'value']);
        // 模板回调的值
        formData[mapping[templateId]] = _get(slot, ['attrs', 'value', 'value']);
      }
    }
    return formData;
  }
};

const EXPRESSION = [
  {
    paramType: PARAMETER_TYPE.FIXED,
    value: true
  },
  {
    paramType: PARAMETER_TYPE.OPERATOR,
    value: "=="
  },
  {
    paramType: PARAMETER_TYPE.FIXED,
    value: true
  }
]

/**
 * 表单验证函数：验证所有必填字段，只有全部通过才返回成功状态
 * @param {Function} func - 预留的自定义函数参数
 * @param {Array} customParamsList - 自定义参数列表
 * @param {Object} customFunctionParams - 自定义函数参数对象
 * @param {string} instanceId - 表单实例ID，用于定位具体表单
 * @returns {Object} 包含验证结果的表达式对象
 */
export const verifyFormValueFun = async (func, customParamsList, customFunctionParams, instanceId) => {
  console.log("验证表单值参数：", func, customParamsList, customFunctionParams, instanceId)

  // 整体验证状态标记，默认初始为通过（true）
  // 注意：一旦有任何字段验证失败，就会被设为false且不会再变回true
  let isValid = true;

  // 克隆基础表达式对象，用于承载最终验证结果
  let expression = _cloneDeep(EXPRESSION);

  // 获取当前表单实例中所有需要渲染的组件
  const components = getRenderComponentsById(instanceId);

  // 遍历每个组件进行验证
  components.forEach(component => {
    // 遍历组件的所有属性（通常对应表单字段）
    Object.keys(component.attrs).forEach(key => {
      // 只处理标记为必填的字段（required: true）
      if (_get(component, ['attrs', key, 'required'], false)) {
        // 获取当前字段的值
        const value = component.attrs[key].value;

        // 记录当前字段的验证状态，默认通过
        let currentValid = true;

        // 1. 处理正则表达式验证规则（如果存在）
        if (_get(component, ['attrs', key, 'rules', 0, 'pattern'])) {
          // 获取正则表达式字符串
          const pattern = component.attrs[key].rules[0].pattern;
          try {
            // 将字符串转为正则对象并进行验证
            const reg = new RegExp(pattern);
            currentValid = reg.test(value);
          } catch (e) {
            // 正则表达式解析失败时，当前字段验证失败
            console.log('正则校验出错：', e);
            currentValid = false;
          }
        }
        // 2. 处理无正则规则的必填项验证（值为空则失败）
        else if (!value) {
          currentValid = false;
        }

        // 更新组件的验证状态（显示错误提示等）
        // 注意：这里用!currentValid是因为通常"验证状态"字段表示"是否出错"
        updateRenderComponentAttr(
          instanceId,
          component,
          'verifyState',
          !currentValid
        );

        // 关键逻辑：只要有一个字段验证失败，整体验证状态就为失败
        if (!currentValid) {
          isValid = false;
        }
      }
    });
  });

  // 将最终验证结果写入表达式对象
  _set(expression, [0, 'value'], isValid);

  // 返回包含验证结果的表达式
  return expression;
};
